/**
 * Some errors are rethrown with custom messages, but the original error is still needed for debugging.
 */
export interface IWrappedError<OrigErr = unknown> {
  readonly originalError: OrigErr;
}

export function isWrappedError(err: unknown): err is IWrappedError {
  return typeof err === 'object'
    && err !== null
    && err.hasOwnProperty('originalError');
}

/**
 * Base class to be used for WrappedError, these have special handlers in the application.
 *
 * NOTE: The browser Error class uses `enumerable: false` and this causes serialization issues.
 */
export abstract class WrappedError<OrigErr = unknown> extends Error {
  public abstract readonly name: string;
  public readonly message: string;
  public readonly location?: string;
  public readonly originalError?: OrigErr;

  constructor(message: string, originalError?: OrigErr, location?: string) {
    // NOTE: To avoid `enumerable: false` issues, the Error class is called without any arguments.
    super();
    this.message = message;
    this.originalError = originalError;
    this.location = location;
  }
}
